import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const supplierManagementRouter: RouteRecordRaw = {
    path: '/supplierManagement',
    component: Layout,
    redirect: 'noredirect',
    meta: {
        title: '供货商管理'
    },
    children: [
        {
            path: '/supplierManagement/supplierAppointmentManagement',
            component: () => import("@/views/main/supplierManagement/supplierAppointmentManagement/supplierAppointmentManagement.vue"),
            name: "supplierAppointmentManagement",
            meta: {
                icon: 'el-icon-user-solid',
                title: '预约审核'
            },
        }
    ]
}
export default supplierManagementRouter